<template>
    <div class="list-content">
        <koin-link :layout="layout"></koin-link>
    </div>
</template>

<script>

import dateMixins from "@/mixins/dateMixins";
import KoinLink from "@/components/payment/KoinLink";
import paymentUtil from "@/components/payment/paymentUtil";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import koinValidator from "@/mixins/validators/koinValidator";

export default {
    name: "KoinComponent",
    mixins: [dateMixins, paymentUtil, alertMixins,koinValidator],
    components: {KoinLink},
    props: {
        memberKey: '',
        paymentType: '',
        koinKey:''
    },
    provide() {
        return {
            koinSetData: this.setData
        }
    },
    data() {
        return {
            layout: '',
            validateKey: [],

        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
    },
    mounted() {
        EventBus.$on('paymentsKoin', this.createKoin)
    },
    beforeDestroy() {
        EventBus.$off('paymentsKoin', this.createKoin)
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(key, value) {
            this[key] = value;

        },
        initConfig() {
            let config = this.returnPaymentConfig(this.paymentType);
            this.layout = config.layout;
            this.validateKey = config.validateKey
        },
        createKoin() {
            let dataKeys = this.validateKey;
            this.$validate(dataKeys).then(success => {
                if (!success) {
                    this.errorAlert("정보를 모두 입력해 주세요");
                    EventBus.$emit(`${layout}Validator`, dataKeys);
                } else {
                    let params = {
                        pd_code: this.type,
                        mb_no: this.memberKey,
                        p_point: this.koin,
                        p_reason: this.reason
                    }
                    if(this.type == 'ADMINMINUS'){
                        params.p_point = params.p_point * -1;
                    }
                    try {
                        this.$api.$payment.updatePoint(params).then(res => res.Data.Result).then(res => {
                            if (res.Info.type !== 1) {
                                this.errorAlert('코인 지급/차감에 실패하였습니다.')
                            } else {
                                this.createAlert({
                                    content: this.type == 'ADMINMINUS'? '차감되었습니다.' : '지급되었습니다.',
                                    hide: () => {
                                        EventBus.$emit('refreshKoinData')
                                    }
                                })
                            }
                        })

                    } catch (e) {
                        console.log(e)
                    }
                }
            })
        },

    },
    watch: {},
}

</script>

<style scoped>

</style>

